import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  Upload,
  message,
  Switch,
  InputNumber,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getBase64, beforeUpload } from "../../../../utils/handlePhoto";
import API from "../../../../services/api-request";
import { baseUrl } from "../../../../config/url-config";
import SelectRFID from "../../../../components/SelectRFID";

const EditUsers = (props) => {
  const [privilege, setPrivilege] = useState(0);
  const [editForm] = Form.useForm();
  const [changePassword, setChangePassword] = useState(false);

  const onSelectPrivilege = (value) => {
    setPrivilege(value);
  };

  const onFinish = async (values) => {
    const {
      name,
      email,
      username,
      password,
      id_privilege,
      image,
      rfid_id,
      discount,
    } = values;

    let dataForm = {};

    dataForm = {
      id: props.selectedData.id,
      name,
      email,
      username,
      password: password ?? "",
      id_privilege,
      image,
      discount: discount ?? 0,
    };

    if (privilege === 6 && props.selectedData.id_privilege === 6) {
      dataForm.rfid_id = rfid_id;
    }

    // if (privilege === 3) {
    //   dataForm.discount = discount;
    // }

    const formData = new FormData();

    for (const property in dataForm) {
      formData.append(`${property}`, dataForm[property]);
    }
    for (var pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    await API.Post(`user/update`, formData)
      .then(() => {
        message.success("User has been saved");
        props.onGetUsers();
        setChangePassword(false);
        props.onShowEdit(false);
      })
      .catch((err) => {
        const errorMessage =
          err?.response?.data?.errors[0].message ?? err.response.data.errors;

        console.error(errorMessage);
        message.info(`${errorMessage}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    setChangePassword(false);
    editForm.setFieldsValue({});
  };

  // File Upload Variable & Function
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.file.originFileObj;
  };

  useEffect(() => {
    setPrivilege(props.selectedData.id_privilege);
    editForm.setFieldsValue(props.selectedData);
    setFileList([
      {
        url: `${baseUrl}/${props.selectedData.image}`,
      },
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
      setFileList([]);
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Users"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={[8, 8]}>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "The input is not a valid email address!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Switch
                size="small"
                onChange={() => setChangePassword(!changePassword)}
                checked={changePassword}
              />
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Change Password"
                name="password"
                rules={[
                  { required: false, message: "Please input your password!" },
                ]}
              >
                <Input.Password disabled={!changePassword} />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Confirm Password"
                name="password2"
                dependencies={["password"]}
                rules={[
                  { required: false },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password disabled={!changePassword} />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Privilege"
                name="id_privilege"
                rules={[
                  { required: true, message: "Please input your privilege!" },
                ]}
              >
                <Select
                  options={props.optionsPrivilege}
                  onChange={onSelectPrivilege}
                />
              </Form.Item>
            </Col>
            {privilege === 6 && props.selectedData.id_privilege === 6 ? (
              <>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="No. RFID"
                    name="rfid_id"
                    rules={[
                      { required: true, message: "Please input No. RFID!" },
                    ]}
                  >
                    <SelectRFID />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}></Col>
              </>
            ) : null}
            {privilege === 3 ? (
              <Col lg={12} md={12} sm={12} xs={24}>
                <Form.Item label="Discount" name="discount">
                  <InputNumber
                    defaultValue={0}
                    controls={false}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            ) : null}
            <Col lg={24} md={24} sm={24} xs={24}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="Upload Photo"
                    name="image"
                    getValueFromEvent={getFile}
                  >
                    <Upload
                      maxCount={1}
                      customRequest={dummyRequest}
                      listType="picture-card"
                      fileList={fileList}
                      beforeUpload={beforeUpload}
                      onPreview={handlePreview}
                      onChange={handleChange}
                    >
                      {fileList.length >= 1 ? null : (
                        <button
                          style={{ border: 0, background: "none" }}
                          type="button"
                        >
                          <PlusOutlined />
                          <div style={{ marginTop: 8 }}>Upload</div>
                        </button>
                      )}
                    </Upload>
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <ul style={{ fontSize: "10px" }}>
                    <li>Must be {"<"} 2MB!</li>
                    <li>Must be JPEG/PNG</li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};
export default EditUsers;
